// src/components/Layout/AdminLayout.js
import React from 'react';
import { Box, Drawer, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useLocation } from 'react-router-dom';

const SIDEBAR_WIDTH = 260;
const SIDEBAR_COLLAPSED_WIDTH = 72;

export default function AdminLayout({ children }) {
  const location = useLocation()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect(() => {
    if (isMobile) {
        setSidebarOpen(false);   // automatically close when navigating
    }
    }, [location.pathname, isMobile]);


  // For mobile: controls whether the drawer is open or closed
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  // For desktop: controls collapsed vs full width
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const handleToggleSidebar = () => {
    console.log(1)
    if (isMobile) {
      // On mobile we open/close the temporary drawer
      setSidebarOpen((prev) => !prev);
    } else {
      // On desktop we collapse/expand the permanent drawer
      setSidebarCollapsed((prev) => !prev);
    }
  };

  // When switching between mobile / desktop, reset sensible defaults
  React.useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
      setSidebarCollapsed(false);
    } else {
      setSidebarOpen(true); // permanent drawer is "open" conceptually
    }
  }, [isMobile]);

  const effectiveSidebarWidth = sidebarCollapsed
    ? SIDEBAR_COLLAPSED_WIDTH
    : SIDEBAR_WIDTH;

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Topbar onToggleSidebar={handleToggleSidebar} />

      {/* Sidebar / Navigation */}
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? sidebarOpen : true}
        onClose={handleToggleSidebar}
        ModalProps={{
          keepMounted: true, // better performance on mobile
        }}
        sx={{
          '& .MuiDrawer-paper': {
            width: isMobile ? SIDEBAR_WIDTH : effectiveSidebarWidth,
            boxSizing: 'border-box',
            borderRight: 0,
          },
        }}
      >
        {/* Pass "collapsed" so Sidebar can render icon-only etc on desktop */}
        <Sidebar collapsed={!isMobile && sidebarCollapsed} />
      </Drawer>

      {/* Main content area */}
      <Box
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          // Push content to the right when the permanent drawer is visible
          ml: {
            xs: 0,
            md: `${effectiveSidebarWidth}px`,
          },
        }}
      >
        <Toolbar />

        {/* Page content */}
        <Box
          sx={{
            flexGrow: 1,
            mx: 'auto',
            width: '100%',
          }}
        >
          <Box sx={{ p: 3 }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
}
